module.exports = __webpack_public_path__ + "static/media/hardy-intro.19d2f222.svg";